import React from "react";
import { Modal } from "react-bootstrap";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";

const AddUpdateBiopsy = ({
  showModal,
  setModalVisible,
  modalAction,
  formData,
  setFormData,
  handleSubmit,
  submitLoading,
}) => {

  const isEdit = modalAction === "edit";
  const isCreate = modalAction === "create";

  const safeDate = (date) => {
    if (!date) return "";
    if (date.includes("T")) return date.split("T")[0];
    return date;
  };

  const safeTime = (time) => {
    if (!time) return null;
    if (time.includes("T")) {
      const t = new Date(time);
      if (isNaN(t)) return null;
      return t.toTimeString().slice(0, 5);
    }
    if (time.length >= 5) return time.slice(0, 5);
    return null;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTimeChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value || "",
    }));
  };

  const renderTimePicker = (label, name, value) => {
    const isDisabled = isEdit && value; 

    return (
      <div className="col-md-6 mb-3">
        <label className="form-label">{label}</label>
        <TimePicker
          onChange={(val) => handleTimeChange(name, val)}
          value={safeTime(value)}
          format="HH:mm"
          disableClock={true}
          clearIcon={null}
          className="w-100"
          disabled={isDisabled}
        />
      </div>
    );
  };

  const renderDateField = (label, name, value) => {
    const isDisabled = isEdit && value;

    return (
      <div className="col-md-6 mb-3">
        <label className="form-label">{label}</label>
        <input
          type="date"
          className="form-control"
          name={name}
          value={safeDate(value)}
          onChange={handleChange}
          disabled={isDisabled}
        />
      </div>
    );
  };

  return (
    <Modal
      centered
      show={showModal}
      onHide={() => setModalVisible(false)}
      size="lg"
      backdrop="static"
    >
      <div className="modal-header">
        <h5 className="modal-title">
          {isCreate ? "Add Biopsy Tracking" : "Update Biopsy Tracking"}
        </h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setModalVisible(false)}
        />
      </div>

      <div className="modal-body">
        <form onSubmit={handleSubmit}>
          <div className="row">

            {/* Appointment ID */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Appointment ID</label>
              <input
                type="text"
                className="form-control"
                name="appointmentId"
                value={formData.appointmentId || ""}
                onChange={handleChange}
                required
                disabled={isEdit} // cannot change appointment id in edit
              />
            </div>

            {/* ✅ ADD MODE → Only 3 fields */}
            {isCreate && (
              <>
                {renderDateField(
                  "Sample Received Date",
                  "sample_rcv_dt",
                  formData.sample_rcv_dt
                )}

                {renderTimePicker(
                  "Sample Received Time",
                  "sample_rcv_time",
                  formData.sample_rcv_time
                )}
              </>
            )}

            {/* ✅ EDIT MODE → Show All Fields */}
            {isEdit && (
              <>
                {renderDateField(
                  "Sample Received Date",
                  "sample_rcv_dt",
                  formData.sample_rcv_dt
                )}

                {renderTimePicker(
                  "Sample Received Time",
                  "sample_rcv_time",
                  formData.sample_rcv_time
                )}

                {renderDateField(
                  "Grossing Date",
                  "grossing_dt",
                  formData.grossing_dt
                )}

                {renderTimePicker(
                  "Grossing Time",
                  "grossing_time",
                  formData.grossing_time
                )}

                {renderDateField(
                  "Slide Formation Date",
                  "slide_formation_dt",
                  formData.slide_formation_dt
                )}

                {renderTimePicker(
                  "Slide Formation Time",
                  "slide_formation_time",
                  formData.slide_formation_time
                )}

                {renderDateField(
                  "Slide Received Date",
                  "slide_rcv_dt",
                  formData.slide_rcv_dt
                )}

                {renderTimePicker(
                  "Slide Received Time",
                  "slide_rcv_time",
                  formData.slide_rcv_time
                )}

                {renderDateField(
                  "Report Date",
                  "report_dt",
                  formData.report_dt
                )}

                {renderTimePicker(
                  "Report Time",
                  "report_time",
                  formData.report_time
                )}
              </>
            )}

          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setModalVisible(false)}
            >
              Close
            </button>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitLoading}
            >
              {submitLoading
                ? "Please wait..."
                : isCreate
                ? "Create"
                : "Update"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddUpdateBiopsy;